import React from "react"
import axios from 'axios'
import { MDCLinearProgress } from '@material/linear-progress';
import $ from "jquery";
import { MDCDataTable } from '@material/data-table';
import { MDCTextField } from '@material/textfield';
import { MDCSnackbar } from '@material/snackbar';
 
var snackbar

String.prototype.replaceAll = function(search, replace){
  return this.split(search).join(replace);
}

Number.prototype.replaceAll = function(search, replace){
  return this
}

class CtrlBoxInput extends React.Component {
  constructor(props) {
    super(props);
  }

  render(props) {
    return <label class="mdc-text-field mdc-text-field--outlined" id={"field" + this.props.id} style={{ marginLeft: "10px", width: this.props.width }}>
      <input type="text" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id={"input" + this.props.id} />
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label" id={"label" + this.props.id}>{this.props.label}</span>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>
    </label>
  }
}

class CtrlBox extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const fields = {
      fields: {
        id: document.querySelector('#fieldNTGSid'),
        type: document.querySelector('#fieldNTGType'),
        name: document.querySelector('#fieldNTGName'),
        descr: document.querySelector('#fieldNTGDescr'),
        linkRequest: document.querySelector('#fieldNTGlinkRequest'),
        countRequest: document.querySelector('#fieldNTGcountRequest'),
        price: document.querySelector('#fieldNTGPrice'),
        cost: document.querySelector('#fieldNTGCost'),
        min: document.querySelector('#fieldNTGMin'), 
        max: document.querySelector('#fieldNTGMax'),
        srvc: document.querySelector('#fieldNTGSrvc'),
        autosmo_sid: document.querySelector('#fieldNTGSrvcAutosmoSid'),
      },
      inputs: {
        id: document.querySelector('#inputNTGSid'),
        type: document.querySelector('#inputNTGType'),
        name: document.querySelector('#inputNTGName'),
        descr: document.querySelector('#inputNTGDescr'),
        linkRequest: document.querySelector('#inputNTGlinkRequest'),
        countRequest: document.querySelector('#inputNTGcountRequest'),
        price: document.querySelector('#inputNTGPrice'),
        cost: document.querySelector('#inputNTGCost'),
        min: document.querySelector('#inputNTGMin'), 
        max: document.querySelector('#inputNTGMax'),
        srvc: document.querySelector('#inputNTGSrvc'),
        autosmo_sid: document.querySelector('#inputNTGSrvcAutosmoSid'),
      },
      labels: {
        id: document.querySelector('#labelNTGSid'),
        type: document.querySelector('#labelNTGType'),
        name: document.querySelector('#labelNTGName'),
        descr: document.querySelector('#labelNTGDescr'),
        linkRequest: document.querySelector('#labelNTGlinkRequest'),
        countRequest: document.querySelector('#labelNTGcountRequest'),
        price: document.querySelector('#labelNTGPrice'),
        cost: document.querySelector('#labelNTGCost'),
        min: document.querySelector('#labelNTGMin'), 
        max: document.querySelector('#labelNTGMax'),
        srvc: document.querySelector('#labelNTGSrvc'),
        autosmo_sid: document.querySelector('#labelNTGSrvcAutosmoSid'),
      }
    }
    console.log(fields)
    this.props.setFields(fields)

    document.querySelector('#saveBtn').onclick = e => {
      var s = {}
      for (const i in fields.inputs)
        s[i] = fields.inputs[i].value.replaceAll("<br>", "\n")
      axios.post("https://nakrutkatop.com:443/api/admin/nicetg/services/edit", s, { withCredentials: true })
        .then(res => {

          if (res.data.ok) snackbar.openText("Сервис успешно изменён")
          else snackbar.openText("Ошибка")
          this.props.loadServices()
        })
    }

    document.querySelector('#addBtn').onclick = e => {
      var s = {}
      for (const i in fields.inputs)
        s[i] = fields.inputs[i].value.replaceAll("<br>", "\n")

      axios.post("https://nakrutkatop.com:443/api/admin/nicetg/services/add", s, { withCredentials: true })
        .then(res => {
          if (res.data.ok) snackbar.openText("Сервис успешно добавлен")
          else snackbar.openText("Ошибка")
          this.props.loadServices()
        })
    }

    document.querySelector('#openBtn').onclick = e => {
      var s = this.props.state.items.filter(el => Number(document.querySelector('#inputNTGSid').value) == el.sid)[0]
      for (const i in fields.fields)
        fields.fields[i].classList.add("mdc-text-field--label-floating")
      for (const i in fields.labels)
        fields.labels[i].classList.add("mdc-floating-label--float-above")
      for (const i in fields.inputs)
        fields.inputs[i].value = s[i] == undefined ? "" : s[i].replaceAll("\n", "<br>")
    }

   
    document.querySelectorAll('.mdc-text-field').forEach(e => new MDCTextField(e))
    snackbar = new MDCSnackbar(document.querySelector('#adminSnackbar'));
    snackbar.openText = function (text) {
      document.querySelector("#adminSnackbarText").innerHTML = text
      snackbar.open()
    }
  }

  render(props) {
    return <div className="ibox" style={{ width: "1000px", flex: "0 0 1000px", maxWidth: "1000px", margin: "24px 24px 24px 0" }}>
      <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Создание и изменение сервисов
  <div>
          
          <button class="mdc-button mdc-button--raised" id="openBtn" style={{ marginLeft: "8px" }}>
            <div class="mdc-button__ripple"></div>
            <i class="material-icons mdc-button__icon" aria-hidden="true">launch</i>
            <span class="mdc-button__label">Открыть по SID</span>
          </button>
          <button class="mdc-button mdc-button--raised" id="saveBtn" style={{ marginLeft: "8px" }} >
            <div class="mdc-button__ripple"></div>
            <i class="material-icons mdc-button__icon" aria-hidden="true">save</i>
            <span class="mdc-button__label">Сохранить</span>
          </button>
          <button class="mdc-button mdc-button--raised" style={{ marginLeft: "8px" }} id="addBtn">
            <div class="mdc-button__ripple"></div>
            <i class="material-icons mdc-button__icon" aria-hidden="true">add</i>
            <span class="mdc-button__label">Добавить</span>
          </button>
        </div>
      </h3>
      <div className="ibox_content" style={{ padding: "10px", margin: "0" }}>
        <div className="Summary_Root__3tu91">

          <CtrlBoxInput id="NTGSid" width="86px" label="SID" />
          <CtrlBoxInput id="NTGType" width="112px" label="Тип" />
          <CtrlBoxInput id="NTGName" width="458px" label="Название" />
          <CtrlBoxInput id="NTGPrice" width="86px" label="Цена" />
          <CtrlBoxInput id="NTGMin" width="86px" label="Мин" />
          <CtrlBoxInput id="NTGMax" width="86px" label="Макс" />
          <CtrlBoxInput id="NTGDescr" width="964px" label="Описание" />
          <CtrlBoxInput id="NTGCost" width="184px" label="Себестоимость" />
          <CtrlBoxInput id="NTGlinkRequest" width="184px" label="Запрос ссылки" />
          <CtrlBoxInput id="NTGcountRequest" width="184px" label="Запрос количества" />
          <CtrlBoxInput id="NTGSrvc" width="185px" label="Источник" />
          <CtrlBoxInput id="NTGSrvcAutosmoSid" width="185px" label="ID в источнике" />

        </div>
      </div>
    </div>
  }
}

class ServicesListBox extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadServices()

    setTimeout(() => {
      const fields = {
        fields: {
          id: document.querySelector('#fieldNTGSid'),
          type: document.querySelector('#fieldNTGType'),
          name: document.querySelector('#fieldNTGName'),
          descr: document.querySelector('#fieldNTGDescr'),
          linkRequest: document.querySelector('#fieldNTGlinkRequest'),
          countRequest: document.querySelector('#fieldNTGcountRequest'),
          price: document.querySelector('#fieldNTGPrice'),
          cost: document.querySelector('#fieldNTGCost'),
          min: document.querySelector('#fieldNTGMin'), 
          max: document.querySelector('#fieldNTGMax'),
          srvc: document.querySelector('#fieldNTGSrvc'),
          autosmo_sid: document.querySelector('#fieldNTGSrvcAutosmoSid'),
        },
        inputs: {
          id: document.querySelector('#inputNTGSid'),
          type: document.querySelector('#inputNTGType'),
          name: document.querySelector('#inputNTGName'),
          descr: document.querySelector('#inputNTGDescr'),
          linkRequest: document.querySelector('#inputNTGlinkRequest'),
          countRequest: document.querySelector('#inputNTGcountRequest'),
          price: document.querySelector('#inputNTGPrice'),
          cost: document.querySelector('#inputNTGCost'),
          min: document.querySelector('#inputNTGMin'), 
          max: document.querySelector('#inputNTGMax'),
          srvc: document.querySelector('#inputNTGSrvc'),
          autosmo_sid: document.querySelector('#inputNTGSrvcAutosmoSid'),
        },
        labels: {
          id: document.querySelector('#labelNTGSid'),
          type: document.querySelector('#labelNTGType'),
          name: document.querySelector('#labelNTGName'),
          descr: document.querySelector('#labelNTGDescr'),
          linkRequest: document.querySelector('#labelNTGlinkRequest'),
          countRequest: document.querySelector('#labelNTGcountRequest'),
          price: document.querySelector('#labelNTGPrice'),
          cost: document.querySelector('#labelNTGCost'),
          min: document.querySelector('#labelNTGMin'), 
          max: document.querySelector('#labelNTGMax'),
          srvc: document.querySelector('#labelNTGSrvc'),
          autosmo_sid: document.querySelector('#labelNTGSrvcAutosmoSid'),
        }
      }

      document.querySelectorAll('#delBtn').forEach(e => e.onclick = (el) => {
        axios.get("https://nakrutkatop.com:443/api/admin/nicetg/services/delete?oid=" + e.getAttribute("oid"), { withCredentials: true })
          .then(res => {
            if (res.data.ok) snackbar.openText("Сервис успешно удалён")
            else snackbar.openText("Ошибка")
            this.props.loadServices()
          })
      })

      document.querySelectorAll('#editBtn').forEach(e => e.onclick = () => {
        var s = this.props.state.items.filter(el => e.getAttribute("oid") == el._id)[0]
        for (const i in fields.fields)
          fields.fields[i].classList.add("mdc-text-field--label-floating")
        for (const i in fields.labels)
          fields.labels[i].classList.add("mdc-floating-label--float-above")
        for (const i in fields.inputs)
          fields.inputs[i].value = s[i] == undefined ? "" : s[i].replaceAll("\n", "<br>")
      })
    }, 1500)

  }

  render(props) {

    const { error, isLoaded, items } = this.props.state;
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Загрузка...</div>;
    } else {
      return (
        <div className="ibox" style={{ width: "1000px", flex: "0 0 1000px", maxWidth: "1000px" }}>
          <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Сервисы</h3>
          <div className="ibox_content" style={{ padding: "0" }}>
            <div className="Summary_Root__3tu91">
              <div className="mdc-data-table" style={{ width: "100%" }}>
                <table className="mdc-data-table__table" aria-label="Dessert calories">
                  <thead>
                    <tr className="mdc-data-table__header-row">

                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">SID</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Тип</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Название</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Цена</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Источник</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">ID в источнике</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">   </th>
                    </tr>
                  </thead>
                  <tbody className="mdc-data-table__content" id="historyTable">
                    {items.map(item => (<tr className="mdc-data-table__row">
                      <td className="mdc-data-table__cell"> {item.id}</td>
                      <td className="mdc-data-table__cell"> {item.type}</td>
                      <td className="mdc-data-table__cell"> {item.name}</td>
                      <td className="mdc-data-table__cell"> {item.price}</td>
                      <td className="mdc-data-table__cell"> {item.srvc}</td>
                      <td className="mdc-data-table__cell"> {item.autosmo_sid}</td>
                      <td className="mdc-data-table__cell"> <button className="mdc-button mdc-button--raised" style={{ width: "36px", minWidth: "36px" }} id="editBtn" oid={item._id}>
                        <div className="mdc-button__ripple" style={{ width: "36px", minWidth: "36px" }}></div>
                        <i className="material-icons mdc-button__icon" aria-hidden="true" style={{ marginRight: "0px", marginLeft: "0px" }}>create</i>
                      </button>
                        <button className="mdc-button mdc-button--raised" style={{ width: "36px", minWidth: "36px", marginLeft: "8px" }} id="delBtn" oid={item._id}>
                          <div className="mdc-button__ripple" style={{ width: "36px", minWidth: "36px" }}></div>
                          <i className="material-icons mdc-button__icon" aria-hidden="true" style={{ marginRight: "0px", marginLeft: "0px" }}>delete</i>
                        </button>
                      </td>
                    </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      );
    }


  }
}
  
class NiceTGTab extends React.Component {
  constructor(props) {
    super(props);
    this.loadServices = this.loadServices.bind(this)
    this.setFields = this.setFields.bind(this)

    this.state = {
      error: null,
      isLoaded: false,
      items: []
    }

    this.fields = []
  }

  setFields(fields) {
    this.fields = fields
    console.log(fields)
  }

  componentDidMount() {

  }

  loadServices() {
    axios.get("https://nakrutkatop.com:443/api/admin/nicetg/services", { withCredentials: true })
      .then(res => {
        document.getElementById("mainContent").style.opacity = 1
        this.setState({
          isLoaded: true,
          items: res.data.services
        }, () => { new MDCDataTable(document.querySelector('.mdc-data-table')); })
      })
  }

  render(props) {
    return <div id="mainContent" style={{ opacity: "0", transition: "1.5s opacity" }}>
      <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
        <CtrlBox loadServices={this.loadServices} state={this.state} setFields={this.setFields} />
      </div>

      <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
        <ServicesListBox loadServices={this.loadServices} state={this.state} fields={this.fields} />
      </div>
    </div>
  }
}



export default NiceTGTab